import { Component, Input, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/core/services';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-report-content-details',
  templateUrl: './report-content-details.component.html',
  styleUrls: ['./report-content-details.component.scss']
})
export class ReportContentDetailsComponent implements OnInit {
  @Input() id!: string;
  reportDetails: any = null;
  loading = false;
  imageBaseUrl = environment.mediaBaseUrl;

  constructor(
    private httpRequestService: HttpRequestService,
    private drawerRef: NzDrawerRef
  ) { }

  ngOnInit(): void {
    if (this.id) {
      this.getReportDetails(this.id);
    }
  }

  getReportDetails(id: string): void {
    this.loading = true;
    this.httpRequestService.request('get', `report-contents/${id}`).subscribe(
      (res: any) => {
        this.loading = false;
        this.reportDetails = res.data;
      },
      (error: any) => {
        this.loading = false;
        console.error('Error fetching report details', error);
      }
    );
  }

  closeDrawer(): void {
    this.drawerRef.close();
  }

  getContentType(): string {
    if (!this.reportDetails) return 'Unknown';
    if (this.reportDetails.question) return 'Question';
    if (this.reportDetails.editorial) return 'Editorial';
    if (this.reportDetails.currentAffair) return 'Current Affair';
    if (this.reportDetails.testSeries) return 'Test Series';
    if (this.reportDetails.test) return 'Test';
    return 'Other';
  }

  getContentTitle(): string {
    if (!this.reportDetails) return '—';
    if (this.reportDetails.question) return this.reportDetails.question.questionText || this.reportDetails.question.title || '—';
    if (this.reportDetails.editorial) return this.reportDetails.editorial.title || '—';
    if (this.reportDetails.currentAffair) return this.reportDetails.currentAffair.title || '—';
    if (this.reportDetails.testSeries) return this.reportDetails.testSeries.name || '—';
    if (this.reportDetails.test) return this.reportDetails.test.name || '—';
    return '—';
  }
}
